import logo from "./logo.svg";
import "./App.css";

function App() {
  return <div className="App">Future site of MyComputerInstructor.com</div>;
}

export default App;
